/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'ai-mate.agent-header-banner-label': 'Asiakaspalvelija-banneri',
  'ai-mate.agent-list.all-agents-section-title': 'Kaikki asiakaspalvelijat',
  'ai-mate.agent-list.beta-lozenge-title': 'Beeta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Muutit asiakaspalvelijan {agentName} omistajaksi {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Omistaja vaihdettu',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Haluatko varmasti poistaa tämän asiakaspalvelijan? Tätä toimintoa ei voida peruuttaa.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Poistetaanko {agentName}?',
  'ai-mate.agent-list.delete-agent-error': 'Asiakaspalvelijaa ei voitu poistaa',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Jotakin meni pieleen asiakaspalvelijaa poistettaessa. Yritä uudelleen hetken kuluttua.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Asiakaspalvelijan poisto epäonnistui',
  'ai-mate.agent-list.delete-agent-error.agent-in-use':
    'Asiakaspalvelija on tällä hetkellä käytössä. Yritä myöhemmin uudelleen.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Kyseistä asiakaspalvelijaa ei löytynyt.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Et voi poistaa asiakaspalvelijoita, joita et ole itse luonut. Ota yhteys asiakaspalvelijan omistajaan.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Poistit asiakaspalvelijan {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Asiakaspalvelija poistettu',
  'ai-mate.agent-list.development-section-title': 'Kehitysasiakaspalvelijat',
  'ai-mate.agent-list.recommended-agents-section-title': 'Suositellut',
  'ai-mate.agent-list.templates-description':
    'Näiden sivupohjien avulla voit luoda oman kehittäjien asiakaspalvelijasi. Valitse työhösi sopiva asiakaspalvelijan sivupohja, valitse Käytä sivupohjaa ja täytä sitten sivupohjan kehote halutuilla tiedoilla, kuten säilö, kansio, kieli ja kirjasto. Luo räätälöityjä kehittäjien asiakaspalvelijoita erilaisten tehtävien, projektien tai säilöjen koodaamista varten.',
  'ai-mate.agent-list.templates-lozenge-title': 'Sivupohja',
  'ai-mate.agent-list.templates-title': 'Koodauksen sivupohjat',
  'ai-mate.agent-message.agent-not-found': 'Asiakaspalvelijaa ei löytynyt',
  'ai-mate.agent-message.convo-title':
    'Keskustelu asiakaspalvelijan {agentName} kanssa laukaistiin upotetusta smart linkistä',
  'ai-mate.agent-message.copy-link': 'Kopioi asiakaspalvelijalinkki',
  'ai-mate.agent-message.prompt': 'Kehote',
  'ai-mate.agent-message.prompt-placeholder': 'Kirjoita viesti asiakaspalvelijalle {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Lähetä',
  'ai-mate.agent-message.view-profile': 'Näytä profiili',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Peruuta',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Poista',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Asiakaspalvelija · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Keskustele asiakaspalvelijan {agentName} kanssa',
  'ai-mate.agent-profile-info.hidden-icon': 'Piilotettu',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Asiakaspalvelija ei näy hakutuloksissa',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Merkitse asiakaspalvelija tärkeäksi',
  'ai-mate.agent-selector.default-agent-description': 'Saa vastauksia, luo uusia ideoita ja tehosta rutiinitöitä.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.profile-card-preview.actions-title': 'Toiminnot',
  'ai-mate.profile-card-preview.agent-default-title': 'Asiakaspalvelija',
  'ai-mate.profile-card-preview.agent-description-label': 'Kuvaus',
  'ai-mate.profile-card-preview.agent-title-label': 'Nimi',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Keskustelun aloittajat',
  'ai-mate.profile-card-preview.empty-actions': 'Ei mitään',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Ei mitään',
  'ai-mate.profile-card-preview.empty-instructions': 'Ei mitään',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ei yhtään valittuna',
  'ai-mate.profile-card-preview.instructions-title': 'Ohjeet',
  'ai-mate.profile-card-preview.knowledge-title': 'Tietopankki',
  'ai-mate.profile-card-preview.regenerate-label': 'Luo uudelleen {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} – kopio',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Järjestä uudelleen vetämällä',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Muutoksia ei voitu tallentaa',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Tapahtui tuntematon virhe. Yritä uudelleen',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Tämänniminen asiakaspalvelija on jo olemassa',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Poista',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': 'Luo keskustelun aloittajia',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {Kentässä {fieldName} saa olla enintään {maxLength,number} merkki} other {Kentässä {fieldName} saa olla enintään {maxLength,number} merkkiä}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Seuraava',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Käynnistä uudestaan',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label':
    'Ohita ja siirry manuaaliseen määritykseen',
  'create-agent.owner-field.confirm-modal-cancel': 'Peruuta',
  'create-agent.owner-field.confirm-modal-confirm': 'Kyllä, jatka',
  'create-agent.owner-field.confirm-modal-content':
    'Olet muuttamassa tämän asiakaspalvelijan omistajaksi käyttäjän {name}. Sen jälkeen et voi enää muokata tai hallita tätä asiakaspalvelijaa.',
  'create-agent.owner-field.confirm-modal-title': 'Olet menettämässä muokkausoikeuden',
  'create-agent.owner-field.owner-description': 'Tämä henkilö voi muokata tai hallita asiakaspalvelijaa.',
  'create-agent.owner-field.owner-label': 'Omistaja',
  'rovo-chat.agent-card.deactivated-name': '{name} (poistettu käytöstä)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Liian monta pyyntöä. Odota hetki.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Yritä uudelleen',
  'rovo-chat.browse-agents.all-agents-button': 'Kaikki',
  'rovo-chat.browse-agents.close-button': 'Sulje',
  'rovo-chat.browse-agents.create-agent-button': 'Luo',
  'rovo-chat.browse-agents.create-an-agent-button': 'Luo asiakaspalvelija',
  'rovo-chat.browse-agents.created-by-label': '<text>tekijä</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Koodausasiakaspalvelijat',
  'rovo-chat.browse-agents.favorite-agents-button': 'Suosikit',
  'rovo-chat.browse-agents.favourited-agent-label': 'Suosikiksi merkitty asiakaspalvelija',
  'rovo-chat.browse-agents.learn-more': 'Lue lisää',
  'rovo-chat.browse-agents.modal-title': 'Selaa asiakaspalvelijoita',
  'rovo-chat.browse-agents.my-agents-button': 'Omat agentit',
  'rovo-chat.browse-agents.no-created-agents':
    'Näyttää siltä, ettet ole vielä luonut yhtään asiakaspalvelijaa. Aloita monistamalla muita olemassa olevia asiakaspalvelijoita tai aloita uuden luominen tyhjästä.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Asiakaspalvelijoita ei ole vielä luotu',
  'rovo-chat.browse-agents.no-results': 'Ei tuloksia',
  'rovo-chat.browse-agents.no-starred-agents':
    'Jos sinulla on suosikkiasiakaspalvelija tai asiakaspalvelija, jota käytät usein, merkitse se suosikiksi, jotta sitä on helpompi ja nopeampi käyttää.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Et ole vielä merkinnyt asiakaspalvelijaa suosikiksi',
  'rovo-chat.browse-agents.search-input.placeholder': 'Hae asiakaspalvelijoita',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Hae sivupohjia',
  'rovo-chat.browse-agents.see-all-agents-button': 'Näytä kaikki asiakaspalvelijat',
  'rovo-chat.browse-agents.starred-agents-button': 'Tärkeät',
  'rovo-chat.browse-agents.templates-button': 'Sivupohjat',
  'rovo-chat.create-agent.actions-section-description':
    'Lisää asiakaspalvelijalle toimintoja, jotta tämä voi suorittaa tehtäviä Jirassa, Confluencessa ja Jira Service Managementissa. <link>Mitä asiakaspalvelijan toiminnot ovat?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Lisää toimintoja',
  'rovo-chat.create-agent.all-content-label': 'Kaikki sisältö',
  'rovo-chat.create-agent.back-button': 'Siirry takaisin',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Et ole vielä luonut asiakaspalvelijaa. Haluatko hylätä sen?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Peruuta',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Kyllä, hylkää asiakaspalvelija',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Keskeneräinen asiakaspalvelija',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Haluatko varmasti hylätä tähän asiakaspalvelijaan tekemääsi muutokset?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Vahvista',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Aloita luonti alusta',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Näitä voi käyttää keskustelun aloittamiseen asiakaspalvelijan kanssa. Jos et keksi mitään, voimme luoda ne sinulle.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Keskustelun aloittajat',
  'rovo-chat.create-agent.create-agent-button': 'Luo',
  'rovo-chat.create-agent.ctions-section-title': 'Toiminnot',
  'rovo-chat.create-agent.description-field-description':
    'Lisätietoja asiakaspalvelijasta saa sen profiilin kuvauksesta.',
  'rovo-chat.create-agent.description-field-label': 'Kuvaus',
  'rovo-chat.create-agent.description-field-placeholder':
    'Kirjoita lyhyt kuvaus asiakaspalvelijasta (esimerkiksi: markkinointiblogin luova kirjoittaja)',
  'rovo-chat.create-agent.instructions-field-description':
    'Miten haluat tämän asiakaspalvelijan käyttäytyvän? Mitä se voi tehdä? <link>Lisätietoja asiakaspalvelijan ohjeiden kirjoittamisesta</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Ohjeet',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Mukauta tämän asiakaspalvelijan ohjeita',
  'rovo-chat.create-agent.intro-description-part-1':
    'Luo asiakaspalvelija, jolla on tarkoitukseen suunniteltua tietoa vastata kysymyksiin, kirjoittaa ja tarkistaa sisältöä ja suorittaa tehtäviä, mikä auttaa sinua edistämään töitä.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Jos et tarvitse apua, voit <bold>ohittaa ja siirtyä manuaaliseen määritykseen.</bold>',
  'rovo-chat.create-agent.intro-description-part-3':
    'Muussa tapauksessa kannattaa pysyä tässä, jolloin voimme yhdessä luoda asiakaspalvelijan.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Luon asiakaspalvelijalle ohjeet kuvailusi perusteella. Kerro vain, mihin suunnittelet käyttäväsi asiakaspalvelijaa.',
  'rovo-chat.create-agent.intro-step-1-title': 'Kuvaile, mitä haluat asiakaspalvelijan tekevän',
  'rovo-chat.create-agent.intro-step-2-content':
    'Mietitään asiakaspalvelijalle yhdessä nimi ja persoonallisuus. Kerro, onko asiakaspalvelija empaattinen, suorasukainen tai hauska.',
  'rovo-chat.create-agent.intro-step-2-title': 'Höystetään asiakaspalvelija luonteenpiirteillä',
  'rovo-chat.create-agent.intro-step-3-content':
    'Valitsemalla <bold>Seuraava</bold> voit tarkistaa uuden asiakaspalvelijan, lisätä toimintoja, tietoja ja profiilikuvan. Kun olet valmis, valitse <bold>Luo.</bold>',
  'rovo-chat.create-agent.intro-step-3-title': 'Tarkista ja luo asiakaspalvelija',
  'rovo-chat.create-agent.intro-title': '👋 Luodaan sinulle asiakaspalvelija',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Kaikki projektit',
  'rovo-chat.create-agent.knowledge-field-description':
    'Määritä asiakaspalvelijan tietämys sallimalla sen viitata vain tarjoamiisi lähteisiin',
  'rovo-chat.create-agent.knowledge-field-label': 'Tietopankki',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Viittaa vain näihin lähteisiin',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Ehdotettu',
  'rovo-chat.create-agent.manage-actions-button-label': 'Hallitse toimintoja',
  'rovo-chat.create-agent.name-field-description': 'Tätä voi käyttää asiakaspalvelijan löytämiseen.',
  'rovo-chat.create-agent.name-field-label': 'Nimi',
  'rovo-chat.create-agent.name-field-placeholder': 'Nimeä asiakaspalvelijasi',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Tapahtui odottamaton virhe. Yritä uudelleen.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hei! Olen apunasi mukautetun asiakaspalvelijan luonnissa. Kerro, mitä haluaisit asiakaspalvelijan tekevän.',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Kirjoita viestisi',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Lähetä',
  'rovo-chat.create-agent.page-title': 'Luo asiakaspalvelija',
  'rovo-chat.create-agent.page-title-edit': 'Muokkaa asiakaspalvelijaa',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Hae sivuja',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Hae työtiloja',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Kaikki',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beeta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Peruuta',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Sulje',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Alle {count,number} toiminnon valitseminen johtaa optimaaliseen suorituskykyyn} other {Alle {count,number} toiminnon valitseminen johtaa optimaaliseen suorituskykyyn}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Tallenna',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Hae toimintoja',
  'rovo-chat.create-agent.select-action-modal-title': 'Lisää toimintoja',
  'rovo-chat.create-agent.select-content-under-label': 'Valitse sisältö kohteessa',
  'rovo-chat.create-agent.select-spaces-label': 'Valitse työtilat',
  'rovo-chat.create-agent.selected-actions-label': 'Valitut toiminnot:',
  'rovo-chat.create-agent.unknown-owner': 'Tuntematon',
  'rovo-chat.create-agent.update-agent-button': 'Päivitä',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Menetät kaikki tallentamattomat muutokset, jos jatkat. Valitse Peruuta, jos haluat jatkaa tämän asiakaspalvelijan muokkausta.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Jatka, hylkää muutokset',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Hylkää muutokset',
  'rovo-chat.view-agent.about-label': 'Tietoja',
  'rovo-chat.view-agent.actions-label': 'Toiminnot',
  'rovo-chat.view-agent.beta-label': 'Beeta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Keskustele asiakaspalvelijan kanssa',
  'rovo-chat.view-agent.close-button': 'Sulje',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopioi',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Kopioi ohjeet',
  'rovo-chat.view-agent.created-by-label': '<text>tekijä</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Suosikkien määrä',
  'rovo-chat.view-agent.go-back-label': 'Siirry takaisin',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Koodilla koostettujen Forge-asiakaspalvelijoiden ohjeet on piilotettu yksityisyyssyistä.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Nämä ohjeet ovat yksityisiä',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Koodilla koostetut Forge-asiakaspalvelijat eivät käytä tyypillisiä tietolähteitä',
  'rovo-chat.view-agent.instructions-label': 'Ohjeet',
  'rovo-chat.view-agent.knowledge-label': 'Tietopankki',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} jäsen} other {{count,number} jäsentä}}',
  'rovo-chat.view-agent.modal-title': 'Selaa asiakaspalvelijoita',
  'rovo-chat.view-agent.no-actions': 'Ei toimintoja',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Tällä asiakaspalvelijalla ei ole mukautettuja ohjeita',
  'rovo-chat.view-agent.no-knowledge-added': 'Ei mukautettuja tietolähteitä',
  'rovo-chat.view-agent.no-teams': 'Ei kuulu mihinkään tiimiin',
  'rovo-chat.view-agent.open-chat-label': 'Avaa keskustelu',
  'rovo-chat.view-agent.reactions-metadata-label': 'Reaktioiden määrä',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-agentti',
  'rovo-chat.view-agent.teams-label': 'Tiimit',
  'rovo-chat.view-agent.users-metadata-label': 'Käyttäjien määrä',
};
